import { useQuery } from "react-query";
import { get } from "../Api";
import { Product } from "./Product";

export const getProductByIds = (ids: string[]): Promise<Product[]> => {
  if (!ids.length) {
    return Promise.resolve([]);
  }
  const productIds = ids.join("&productIds=");
  return get<Product[]>(`pricing/public/Product/list?productIds=${productIds}`);
};

export const useProducts = (ids: string[]) => {
  const key = ids.join(",");
  const fetcher = () => getProductByIds(ids);
  return useQuery(key, fetcher);
};
